import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Rating from './Rating';
import Badge from './Badge';

/**
 * PlaceCard — image card for temples, ghats and experiences.
 * props: image, title, subtitle, to, meta [{icon,text}], rating, reviews, badge, cta
 */
export default function PlaceCard({ image, title, subtitle, to = '#', meta = [], rating, reviews, badge, cta = 'Explore', hindi, className = '' }) {
  return (
    <Link to={to} className={`card card--hover place-card${className ? ` ${className}` : ''}`}>
      <div className="card__media">
        <img src={image} alt={title} loading="lazy" onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} />
        {badge && <Badge variant="soft" className="place-card__badge">{badge}</Badge>}
      </div>
      <div className="card__body">
        <div className="place-card__head">
          <h3 className="h-card place-card__title">{title}</h3>
          {rating != null && <Rating value={rating} count={reviews} />}
        </div>
        {hindi && <div className="place-card__hindi hindi">{hindi}</div>}
        {subtitle && <p className="place-card__sub">{subtitle}</p>}
        {meta.length > 0 && (
          <ul className="place-card__meta">
            {meta.map((m, i) => (
              <li key={i}><Icon name={m.icon} size={14} /><span>{m.text}</span></li>
            ))}
          </ul>
        )}
        <span className="link-arrow">{cta}<Icon name="arrow-right" size={15} /></span>
      </div>
    </Link>
  );
}
